import React from "react"
//import I18n from "i18n-js/index.js.erb"

export default class SingleSelect extends React.Component {
  constructor(props) {
    super(props);
  };

  componentDidMount() {
    $(this.refs.singleSelect).select2({
      placeholder: I18n.t('select_ellipsis'),
      allowClear: false,
      disabled: this.props.disabled,
    }).on('change', (e) => {
      this.props.onChange(e.target.value)
      }).val(this.props.defaultValue).trigger('change')
  };

  shouldComponentUpdate(nextProps, nextState) {
    if(this.props.defaultValue != nextProps.defaultValue) {
      $(this.refs.singleSelect).select2({
        placeholder: I18n.t('select_ellipsis'),
        allowClear: false,
      }).val(nextProps.defaultValue).trigger('change')
    };

    if(this.props.disabled != nextProps.disabled) {
      $(this.refs.singleSelect).select2({
        placeholder: I18n.t('select_ellipsis'),
        allowClear: false,
        disabled: nextProps.disabled,
      }).trigger('change')
    }
    return true
  };

  render() {
    return(
      <div className="single-select">
        <select className="form-control" ref="singleSelect" style={{ width: '100%', minHeight: 33 }} id="select">
          {this.renderOptions()}
        </select>
        {this.renderFieldError()}
      </div>
    );
  };

  renderOptions() {
    if(this.props.options && this.props.options.length) {
      var options = this.props.options.map((option) => {
        return <option key={option.value} value={option.value}> {I18n.t(option.name)}</option>
      });
      options.unshift(<option key='0' value=''></option>)
    };
    return options
  };

  renderFieldError() {
    if (this.props.hasError && this.props.hasError.includes('has-errors')) {
      if ($('.single-select').find('.select2-container--default .select2-selection--single .select2-selection__rendered')[this.props.idx] && !$('.single-select').find('.select2-container--default .select2-selection--single .select2-selection__rendered')[this.props.idx].className.includes('has-errors')) {
        $('.single-select').find('.select2-container--default .select2-selection--single .select2-selection__rendered')[this.props.idx].className += this.props.hasError
        // $('.single-select').find('.select2-container--default .select2-selection--single .select2-selection__rendered').addClass(this.props.hasError)
      }
    }
    if (this.props.hasError && !this.props.hasError.includes('has-errors')) {
      if ($('.single-select').find('.select2-container--default .select2-selection--single .select2-selection__rendered')[this.props.idx] && $('.single-select').find('.select2-container--default .select2-selection--single .select2-selection__rendered')[this.props.idx].className.includes('has-errors')) {
        var select = $('.single-select').find('.select2-container--default .select2-selection--single .select2-selection__rendered')[this.props.idx]
        select.className = select.className.replace(/has-errors/g, "")
        // $('.single-select').find('.select2-container--default .select2-selection--single .select2-selection__rendered').addClass(this.props.hasError)
      }
    }
  };
};
